import React, { useContext, useEffect, useState } from 'react'
import Modal from '../Modal'
import { ReactComponent as Cort } from './icons/cort.svg'
import { ReactComponent as Info } from './icons/info.svg'
import Button from '../Forms/Button'
import { submitCortForm, useCortForm } from '../Sidebar/components/ContactForm'
import Input from '../Forms/Input'
import { captureEvent } from '../../analytics'
import { analyticsEvents } from '../../analytics/events'
import { useStore } from '../../store'
import { objectCopy } from '../../helpers/general'
import { AppConfigContext } from '../../context/AppConfig'
import { EResult } from '../Sidebar/components/ContactForm/components/Result'
import PropertyLogo from '../PropertyLogo'
function CTFCloseIntentModal({ onClose = () => {} }) {
  const { setFormData } = useStore()
  const { isSWApp, isPDApp, isAvalonApp } = useContext(AppConfigContext)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    captureEvent(analyticsEvents.EXIT_INTENT_POPUP_VIEWED)
  }, [])

  async function onSubmit() {
    setLoading(true)
    captureEvent(analyticsEvents.EXIT_INTENT_POPUP_CONNECT_TAPPED)
    if (isSWApp || isAvalonApp) {
      captureEvent(analyticsEvents.EXIT_INTENT_POPUP_CONNECT_SUCCEEDED)
      // Adding timeout to avoid race condition between iframe closing and actual event sending
      setTimeout(() => {
        onClose(EResult.SUCCESS)
      }, 500)
      return
    }
    await submitCortForm(
      {
        ...formik.values,
      },
      () => {
        captureEvent(analyticsEvents.EXIT_INTENT_POPUP_CONNECT_SUCCEEDED)
        // Adding timeout to avoid race condition between iframe closing and actual event sending
        setTimeout(() => {
          onClose(EResult.SUCCESS)
        }, 500)
        setLoading(false)
      },
      () => {
        // Adding timeout to avoid race condition between iframe closing and actual event sending
        setTimeout(() => {
          onClose(EResult.ERROR)
        }, 500)
        setLoading(false)
      },
      true,
    )
  }

  const formik = useCortForm(onSubmit)

  useEffect(() => {
    setFormData(objectCopy(formik.values))
  }, [formik.values, setFormData])

  function getTitle() {
    if (isSWApp) {
      return 'Wait, did you know we offer turnkey packages for rent or purchase?'
    } else {
      return 'Wait, did you know we offer Move-In Ready® packages?'
    }
  }

  return (
    <Modal className="pt-[0] max-w-[420px]">
      {!isSWApp && (
        <>
          {isPDApp ? (
            <div className='flex items-center w-full justify-center'>
              <Cort />
              <PropertyLogo className='ml-[16px]' />
            </div>
          ) : (
            <div className="flex justify-center">
              <Cort />
            </div>
          )}
        </>
      )}
      {isSWApp && (
        <div className="flex justify-center mt-[40px]">
          <Info />
        </div>
      )}
      <div>
        <div
          className={`text-[18px] font-semibold ${
            isSWApp ? 'text-black' : 'text-[var(--brand-color)]'
          } leading-[24px] my-[24px]`}
        >
          {getTitle()}
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div>
            <div className="grid grid-cols-2 gap-[16px]">
              <Input
                name="first_name"
                value={formik.values.first_name}
                onChange={formik.handleChange}
                required
                placeholder="First Name*"
              />
              <Input
                name="last_name"
                value={formik.values.last_name}
                onChange={formik.handleChange}
                required
                placeholder="Last Name*"
              />

              <div className="w-full col-span-2">
                <Input
                  name="email"
                  value={formik.values.email}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  required
                  placeholder="Email*"
                  className="w-full"
                />
                {formik.errors.email && (
                  <div className="text-[red] text-[12px] font-bold mt-2">{formik.errors.email}</div>
                )}
              </div>
            </div>
          </div>
          <div>
            <Button
              type="submit"
              className={`w-full ${isSWApp || isAvalonApp ? 'bg-[var(--brand-color)]' : 'bg-black'} my-[16px]`}
              loading={loading}
            >
              {isPDApp || isAvalonApp ? 'Contact Property' : 'Connect'}
            </Button>
            <Button
              onClick={() => {
                captureEvent(analyticsEvents.EXIT_INTENT_POPUP_EXIT_TAPPED)
                onClose()
              }}
              className="w-full  bg-transparent !text-[#3D4256] border-[1px] border-solid border-[#C7CCD9]"
            >
              No, Thanks
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default CTFCloseIntentModal
